import type { StreamConfiguration } from '@/index'
import { StreamType } from '@/index'
import { env } from '@/infra/config/env'

export const CONVERSATION_STREAM_CONFIG: StreamConfiguration = {
  type: StreamType.CONVERSATION,
  endpoints: {
    connect: env.SSE_CONVERSATION_CONNECT_PATH,
    disconnect: env.SSE_CONVERSATION_DISCONNECT_PATH,
  },
  eventConfig: {
    streamName: env.SSE_CONVERSATION_STREAM_NAME,
    eventNames: [env.SSE_CONVERSATION_EVENT_NAME],
    connectionMessage: env.SSE_CONVERSATION_CONNECTION_MESSAGE,
  },
}

export const ACTIVITY_STREAM_CONFIG: StreamConfiguration = {
  type: StreamType.ACTIVITY,
  endpoints: {
    connect: env.SSE_ACTIVITY_CONNECT_PATH,
    disconnect: env.SSE_ACTIVITY_DISCONNECT_PATH,
  },
  eventConfig: {
    streamName: env.SSE_ACTIVITY_STREAM_NAME,
    eventNames: [env.SSE_ACTIVITY_EVENT_NAME],
    connectionMessage: env.SSE_ACTIVITY_CONNECTION_MESSAGE,
  },
}

export const STATUS_STREAM_CONFIG: StreamConfiguration = {
  type: StreamType.STATUS,
  endpoints: {
    connect: env.SSE_STATUS_CONNECT_PATH,
    disconnect: env.SSE_STATUS_DISCONNECT_PATH,
  },
  eventConfig: {
    streamName: env.SSE_STATUS_STREAM_NAME,
    eventNames: [env.SSE_STATUS_SESSION_EVENT_NAME, env.SSE_STATUS_HOST_EVENT_NAME],
    connectionMessage: env.SSE_STATUS_CONNECTION_MESSAGE,
  },
}

export const STREAM_CONFIGS: ReadonlyMap<StreamType, StreamConfiguration> = new Map([
  [StreamType.CONVERSATION, CONVERSATION_STREAM_CONFIG],
  [StreamType.ACTIVITY, ACTIVITY_STREAM_CONFIG],
  [StreamType.STATUS, STATUS_STREAM_CONFIG],
])

export function getStreamConfig(type: StreamType): StreamConfiguration {
  const config = STREAM_CONFIGS.get(type)
  if (!config) {
    throw new Error(`No configuration found for stream type: ${type}`)
  }
  return config
}

export const ACTIVE_STREAM_TYPES: readonly StreamType[] = [
  StreamType.CONVERSATION,
  StreamType.ACTIVITY,
  StreamType.STATUS,
]

export const RECONNECTION_CONFIG = {
  initialDelayMs: env.SSE_RECONNECT_INITIAL_DELAY_MS,
  maxDelayMs: env.SSE_RECONNECT_MAX_DELAY_MS,
  backoffMultiplier: env.SSE_RECONNECT_BACKOFF_MULTIPLIER,
  maxAttempts: env.SSE_RECONNECT_MAX_ATTEMPTS,
} as const

export function calculateReconnectDelay(attemptNumber: number): number {
  const delay =
    RECONNECTION_CONFIG.initialDelayMs *
    Math.pow(RECONNECTION_CONFIG.backoffMultiplier, attemptNumber)
  return Math.min(delay, RECONNECTION_CONFIG.maxDelayMs)
}
